// extracted by mini-css-extract-plugin
export default {"wrapper":"SimplePanels_wrapper__3RSoK","title":"SimplePanels_title__UKYG8"};